import React__default from 'react';
import { TimeField, DateInput, DateSegment } from 'react-aria-components';
import { WarningIcon } from '../icons/WarningIcon.js';
import './TimeInput.scss';

const TimeInput = ({ size = 'large', variant = 'outline', rounding = '10', className, ariaLabel, isTouched, hasError, isDisabled, isReadOnly, ...reactAriaTimeFieldProps }) => {
    const showInvalidState = !!hasError;
    return (React__default.createElement(TimeField, { ...reactAriaTimeFieldProps, "data-rev-component": 'time-input', className: className, "aria-label": ariaLabel, "aria-invalid": showInvalidState, isInvalid: showInvalidState, isDisabled: isDisabled, isReadOnly: isReadOnly },
        React__default.createElement("div", { className: 'time-input-group--rev', "data-rev-variant": variant, "data-rev-size": size, "data-rev-rounding": rounding, "data-disabled": isDisabled || isReadOnly, "data-invalid": showInvalidState },
            React__default.createElement(DateInput, { className: 'time-input-segments--rev' }, (segment) => (React__default.createElement(DateSegment, { className: 'time-input-segment--rev', segment: segment })))),
        hasError && typeof hasError === 'string' && (React__default.createElement("div", { className: 'time-input-error--rev', role: 'alert' },
            React__default.createElement(WarningIcon, null),
            hasError))));
};
TimeInput.displayName = 'TimeInput';

export { TimeInput };
//# sourceMappingURL=TimeInput.js.map
